// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-compass {
  position: absolute;
  bottom: 25px;
  right: 5px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  user-select: none;
  pointer-events: auto;
  background-color: var(--background-color-1);
  box-shadow: 1px 3px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 2px;
  opacity: 0.85;
}

.cesium-compass .out-ring {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 50%;
  transition: all ease 0.2s;
  fill: #173147b3;
}
.cesium-compass:hover .out-ring {
  border: 1px solid var(--primary-color-1);
}

.cesium-compass .out-ring svg {
  width: 25px;
  height: 25px;
  fill: var(--color-icon-2);
}

.cesium-compass:hover .out-ring svg {
  fill: var(--primary-color-1);
}
`, "",{"version":3,"sources":["webpack://./src/utils/compass/styles/compass.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".cesium-compass {\r\n  position: absolute;\r\n  bottom: 25px;\r\n  right: 5px;\r\n  width: 32px;\r\n  height: 32px;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  pointer-events: auto;\r\n  background-color: var(--background-color-1);\r\n  box-shadow: 1px 3px 10px 0 rgba(0, 0, 0, 0.5);\r\n  border-radius: 50%;\r\n  padding: 2px;\r\n  opacity: 0.85;\r\n}\r\n\r\n.cesium-compass .out-ring {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border: 1px solid transparent;\r\n  background-repeat: no-repeat;\r\n  background-size: contain;\r\n  border-radius: 50%;\r\n  transition: all ease 0.2s;\r\n  fill: #173147b3;\r\n}\r\n.cesium-compass:hover .out-ring {\r\n  border: 1px solid var(--primary-color-1);\r\n}\r\n\r\n.cesium-compass .out-ring svg {\r\n  width: 25px;\r\n  height: 25px;\r\n  fill: var(--color-icon-2);\r\n}\r\n\r\n.cesium-compass:hover .out-ring svg {\r\n  fill: var(--primary-color-1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
